// extracted by mini-css-extract-plugin
export default {"LogsFilters":"LogsPage_LogsFilters__jEcsD"};